// Gives webpack time for async load resources
import('./bootstrap')
